import { render, staticRenderFns } from "./uploadRecord.vue?vue&type=template&id=4f70f4cc&scoped=true"
import script from "./uploadRecord.vue?vue&type=script&lang=js"
export * from "./uploadRecord.vue?vue&type=script&lang=js"
import style0 from "./uploadRecord.vue?vue&type=style&index=0&id=4f70f4cc&prod&scoped=true&lang=scss"
import style1 from "./uploadRecord.vue?vue&type=style&index=1&id=4f70f4cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70f4cc",
  null
  
)

export default component.exports